/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Full_Short_Owl_EnjoyInputs */

const en_full_short_owl_enjoy = /** @type {(inputs: Full_Short_Owl_EnjoyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Select (${i?.count})`)
};

const de_full_short_owl_enjoy = /** @type {(inputs: Full_Short_Owl_EnjoyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Auswählen (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Select ({count})" |
*
* @param {Full_Short_Owl_EnjoyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const full_short_owl_enjoy = /** @type {((inputs: Full_Short_Owl_EnjoyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Full_Short_Owl_EnjoyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_full_short_owl_enjoy(inputs)
	return de_full_short_owl_enjoy(inputs)
});